import { useEffect } from 'react';

export const useIpFetcher = (ipinfoKey) => {
  const lsKey = 'user_location';

  useEffect(() => {
    if (
      typeof window == 'undefined' ||
      typeof localStorage == 'undefined' ||
      !ipinfoKey
    ) {
      return;
    }

    // Check if the IP info stored within the last day
    const stored = localStorage.getItem(lsKey);
    if (stored) {
      const { timestamp, country_code } = JSON.parse(stored);
      const ONE_HOUR = 60 * 60 * 1000;
      if (Date.now() - timestamp < ONE_HOUR && country_code) {
        return;
      }
    }

    // Fetch in the background, non-blocking
    fetch(`https://api.ipinfo.io/lite/me?token=${ipinfoKey}`)
      .then((res) => res.json())
      .then((data) => {
        localStorage.setItem(
          lsKey,
          JSON.stringify({
            country_code: data.country_code,
            country: data.country,
            timestamp: Date.now(),
          })
        );
      })
      .catch((err) => console.error('IP fetch failed:', err));
  }, []);

  const getUserLocationInfo = () => {
    return JSON.parse(localStorage.getItem(lsKey) || '{}');
  };

  return { getUserLocationInfo };
};
